define('plugin/facebook-pixel/PromotionInflator',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Promotion inflator for Facebook Pixel plugin
     *
     * @class PromotionInflator
     */
    return Marionette.Object.extend({
        inflate: function (contentData, model, data) {
            var promotionData = model.get('promotion');
            _.extend(contentData, {
                content_ids: [promotionData.id],
                content_type: model.get('type'),
                contents: [{
                    id: promotionData.id,
                    name: promotionData.name,
                    discount: parseFloat(promotionData.discount),
                    discount_type: promotionData.discount_type,
                    price: parseFloat(promotionData.price)
                }]
            });
        }
    });

});

